module.exports = __webpack_public_path__ + "assets/img/worldviewImg-00c2459b.png";